import { AbilityBuilder, Ability } from '@casl/ability';

export function defineAbilitiesFor(user) {
  const perfis = (user && user.perfis) || [];

  const { rules } = AbilityBuilder.define((can) => {
    if (perfis.includes('SUDO')) {
      can('manage', 'all');
    }

    if (perfis.includes('ADMIN')) {
      can('manage', 'Pedido');
      can('manage', 'MapaProdutos');
      can('manage', 'ProdutoBloqueado');
      can('manage', 'Aprovador');
      can('read', 'Dashboard');
      can('manage', 'PontoAtendimento');
      can(['manage'], 'PedidoDevolucao');
      can(['manage'], 'PedidoEmMapa');
      can(['manage'], 'ImportarPedido');
    }

    if (perfis.includes('ADMIN_BIO')) {
      can('manage', 'Pedido');
      can('read', 'Dashboard');
    }

    if (perfis.includes('APROVADOR')) {
      can(['manage'], 'Pedido');
      can('read', 'PontoAtendimento');
      can(['manage'], 'PedidoDevolucao');
      can(['manage'], 'PedidoEmMapa');
      can(['manage'], 'ImportarPedido');
    }

    if (perfis.includes('SOLICITANTE')) {
      can(['manage'], 'Pedido');
    }

    if (perfis.includes('PONTO_ATENDIMENTO')) {
      // can(['create', 'read'], 'Pedido');
      can(['create', 'read', 'update'], 'PedidoDevolucao');
      can(['create', 'read', 'update'], 'PedidoEmMapa');
      can(['create', 'read', 'update'], 'ImportarPedido');
    }
  });

  return new Ability(rules);
}
